(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lumiova-urgency"] && !Shopify.designMode) return;
  try {
    (function () {
    function tick(el) {
      var cutoff = parseInt(el.getAttribute('data-cutoff') || '20', 10);
      var nowParis = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Paris' }));
      var target = new Date(nowParis);
      target.setHours(cutoff, 0, 0, 0);
      var diff = target.getTime() - nowParis.getTime();
      var today = el.querySelector('[data-msg-today]');
      var after = el.querySelector('[data-msg-after]');
      var timer = el.querySelector('[data-timer]');
      if (diff <= 0) {
        if (today) today.style.display = 'none';
        if (after) after.style.display = '';
        return;
      }
      if (today) today.style.display = '';
      if (after) after.style.display = 'none';
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (timer) {
        timer.textContent =
          (h < 10 ? '0' + h : h) + 'h ' +
          (m < 10 ? '0' + m : m) + 'm ' +
          (s < 10 ? '0' + s : s) + 's';
        var urgentMin = parseInt(el.getAttribute('data-urgent') || '60', 10);
        if (diff <= urgentMin * 60000) {
          timer.classList.add('is-urgent');
        } else {
          timer.classList.remove('is-urgent');
        }
      }
    }
    function init() {
      var els = document.querySelectorAll('lumiova-urgency');
      els.forEach(function (el) {
        if (el.dataset.lumiovaInit) return;
        el.dataset.lumiovaInit = '1';
        tick(el);
        setInterval(function () { tick(el); }, 1000);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
